import React from 'react'
import { Region } from '@enonic/react-components';

import Hero from '/react4xp/components/Hero'

import { LandingPageProps } from './landing-page.d'

function LandingPageLayout(props: LandingPageProps) {
    return (
        <>
            <Hero
                layout={props.hero.layout}
                breadcrumbs={props.hero.breadcrumbs}
                image={props.hero.image}
                title={props.hero.title}
                description={props.hero.description}
                button={props.hero.button}
            />
            <Region name={props.regions.main.name} regionData={props.regions.main} />
        </>
    )
}

export default (props) => <LandingPageLayout {...props} />
